export * from "./TriangleClassification";
export * from "./PythagorasTheorem";
export * from "./TrigonometricRatios";

export const basicTrigonometryNotionsItems = {
  "Clasificación de triángulos": {
    path: "/nociones-basicas-trigonometria/triangulos",
  },
  "Teorema de Pitágoras": {
    path: "/nociones-basicas-trigonometria/teorema-pitagoras",
  },
  "Razones trigonométricas": {
    path: "/nociones-basicas-trigonometria/razones-trigonometricas",
  },
};
